import React from 'react';
import { DataSubjectRightForm, OtpForm, SuccessMessage } from '@ui/components/organisms';
import { useDataSubjectRightLookups } from '@services/DataSubjectRight';
import { useTranslate } from '@translations/useTranslate';
import { useDocumentTitle } from '@hooks/index';

export const DsrRequest: React.FC = () => {
  const { t } = useTranslate();
  useDocumentTitle(t('page.title.dsr'));
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isEmail, setIsEmail] = React.useState(false);
  const [isOwn, setIsOwn] = React.useState(true);
  const [verificationText, setVerificationText] = React.useState('');
  const [requestId, setRequestId] = React.useState('');
  const [jiraTicket, setJiraTicket] = React.useState('');
  const changeCurrentPage = React.useCallback((page) => {
    setCurrentPage(page);
  }, []);
  const { data: lookups, isLoading: isLookupsLoading } = useDataSubjectRightLookups();
  return lookups && !isLookupsLoading ? (
    <>
      <h2 className="w-100 text-center fw-bold pt-2 pb-3">{t('dsr.form.title')}</h2>
      {currentPage === 1 && (
        <DataSubjectRightForm
          lookups={lookups}
          onRequestSuccess={(isSubmittedEmail, submittedVerificationText, isOwn, requestId) => {
            setIsEmail(isSubmittedEmail);
            setVerificationText(submittedVerificationText);
            setRequestId(requestId);
            setIsOwn(isOwn);
            changeCurrentPage(2);
          }}
        />
      )}
      {currentPage === 2 && (
        <OtpForm
          isEmail={isEmail}
          verificationText={verificationText}
          requestId={requestId}
          onSubmit={(ticket) => {
            setJiraTicket(ticket);
            changeCurrentPage(3);
          }}
        />
      )}
      {currentPage === 3 && <SuccessMessage isOwn={isOwn} ticketNumber={jiraTicket} />}
    </>
  ) : (
    <></>
  );
};
